import { React, useEffect, useState } from 'react';
import { BsHouseAdd } from 'react-icons/bs';
import { FaLanguage, FaRegComments, FaUserFriends } from 'react-icons/fa';
import { IoCarOutline } from 'react-icons/io5';
import { MdAccountCircle, MdClose, MdLogin, MdMenu, MdOutlineAppRegistration, MdOutlineEditCalendar, MdPublishedWithChanges } from 'react-icons/md';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../Button/Button';
import './Navbar.css'
import { useTranslation } from 'react-i18next';
import CustomModal from '../CustomModal';
import { BiCalendarCheck } from 'react-icons/bi';

const base_url = process.env.REACT_APP_BASE_URL

const Navbar = () => {
    const [searchParams] = useSearchParams();
    const participation_type = JSON.parse(localStorage.getItem("participation_type"));
    const getTokenFromLocalStorage = JSON.parse(localStorage.getItem("token"));
    const customerUrl = `https://livechat.snldhamma.org/customer?token=${getTokenFromLocalStorage}`;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    const { t, i18n } = useTranslation();
    const handleLanguageChange = (e) => {
        const selectedLanguage = e.target.value;
        i18n.changeLanguage(selectedLanguage);
        localStorage.setItem("i18nextLng", selectedLanguage);
    };
    const storedLang = localStorage.getItem("i18nextLng") || 'cn';
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);
    const navigate = useNavigate();
    const handleClick = () => { setClick(!click) };
    const closeMobileMenu = () => { setClick(false) };

    const logout = () => {
        localStorage.clear();
        window.location.reload();
    };
    const showButton = () => {
        if (window.innerWidth <= 768) {
            setButton(false);
        } else {
            setButton(true);
        }
    }
    const handleLanguageClick = () => {
        closeMobileMenu();
        toggleModal();
    }

    useEffect(() => {
        showButton();
        const selectedLanguage = searchParams.get("lang");

        if (selectedLanguage) {
            i18n.changeLanguage(selectedLanguage);
            localStorage.setItem("i18nextLng", selectedLanguage);
            navigate(window.location.pathname, { replace: true });
        }
    }, []);

    window.addEventListener('resize', showButton);
    return (
        <>
            <CustomModal
                hideModal={toggleModal}
                open={isModalOpen}
                performAction={toggleModal}
                title="更換語言 Switch Language"
                children={
                    <select className="form-select" onChange={handleLanguageChange} value={storedLang}>
                        <option value="en">English</option>
                        <option value="cn">中文</option>
                    </select>
                }
            />
            <nav className='navbar shadow'>
                <div className="navbar-container">
                    <button
                        className="navbar-logo"
                        disabled={participation_type === null}
                        onClick={participation_type === "Online" ? () => navigate(`${base_url}/online-home`) : () => navigate(`${base_url}/`)}
                    >
                        <img src={`${base_url}/images/Shi-Ne-Ling-Logo.png`} alt="" />
                        <div>
                            <p className="mb-0 text-center"><strong>{t("navbar.homepage")}</strong></p>
                        </div>
                    </button>
                    <div className="menu-icon" onClick={handleClick}>
                        {click ? <MdClose className='fs-3' /> : <MdMenu className='fs-3' />}
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        {
                            // haven't login
                            participation_type == null
                                ?
                                <>
                                    {/* <li className='nav-item'>
                                        <Link to="https://www.shineling.org:3004" target="_blank" rel="noopener noreferrer" className="nav-links" onClick={closeMobileMenu}>
                                            <FaUserFriends className='fs-3' /> {t("navbar.chatbot")}
                                        </Link>
                                    </li> */}
                                    {/* <li className='nav-item'>
                                        <Link to="https://www.shineling.org:3001/pre-retreat" target="_blank" rel="noopener noreferrer" className="nav-links" onClick={closeMobileMenu}>
                                            <MdOutlineEditCalendar className='fs-3' /> {t("navbar.preretreat")}
                                        </Link>
                                    </li> */}
                                    <li className='nav-item'>
                                        <Link to={`${base_url}/course_registration`} className="nav-links" onClick={closeMobileMenu}>
                                            <MdOutlineAppRegistration className='fs-3' /> {t("navbar.courseRegistration")}
                                        </Link>
                                    </li>
                                    <li className='nav-item'>
                                        <Link to={`${base_url}/search_eligibility`} className="nav-links" onClick={closeMobileMenu} target="_blank" rel="noopener noreferrer">
                                            <MdPublishedWithChanges className='fs-3' /> {t("navbar.eligibilityCheck")}
                                        </Link>
                                    </li>
                                    {/* reopen when want to open */}
                                    {/* <li className='nav-item'>
                                        <Link to={`${base_url}/login`} className="nav-links-mobile" onClick={closeMobileMenu}>
                                            <MdLogin className='fs-3' /> {t("navbar.login")}
                                        </Link>
                                    </li> */}
                                    <li className='nav-item'>
                                        <button className="nav-links-mobile disabled-btn" disabled>
                                            <MdLogin className='fs-3' /> {t("navbar.login")}
                                        </button>
                                    </li>
                                </>
                                :
                                <>

                                    {participation_type === "Online" ? (
                                        <>
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/online-personal-info`} className="nav-links" onClick={closeMobileMenu}>
                                                    <MdAccountCircle className='fs-3' /> {t("navbar.account")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link to={customerUrl} target="_blank" rel="noopener noreferrer" className="nav-links" onClick={closeMobileMenu}>
                                                    <FaUserFriends className='fs-3' /> {t("navbar.chatbot")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/view_attendance`} className="nav-links" onClick={closeMobileMenu}>
                                                    <BiCalendarCheck className='fs-3' /> {t("navbar.attendance")}
                                                </Link>
                                            </li>
                                            {/* <li className='nav-item'>
                                                <Link to="https://www.shineling.org:3001/pre-retreat" target="_blank" rel="noopener noreferrer" className="nav-links" onClick={closeMobileMenu}>
                                                    <MdOutlineEditCalendar className='fs-3' /> {t("navbar.preretreat")}
                                                </Link>
                                            </li> */}
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/course_registration`} className="nav-links" onClick={closeMobileMenu}>
                                                    <MdOutlineAppRegistration className='fs-3' /> {t("navbar.courseRegistration")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/search_eligibility`} className="nav-links" onClick={closeMobileMenu} target="_blank" rel="noopener noreferrer">
                                                    <MdPublishedWithChanges className='fs-3' /> {t("navbar.eligibilityCheck")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link className="nav-links-mobile" onClick={() => { closeMobileMenu(); logout(); }}>
                                                    <MdLogin className='fs-3' /> {t("navbar.logout")}
                                                </Link>
                                            </li>
                                        </>
                                    ) : (
                                        // Regular student menu items - show all options
                                        <>
                                            {/* <li className='nav-item'>
                                                <Link to={`${base_url}/view-personal-info`} className="nav-links" onClick={closeMobileMenu}>
                                                    <MdAccountCircle className='fs-3' /> {t("navbar.account")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/view-accommodation`} className="nav-links" onClick={closeMobileMenu}>
                                                    <BsHouseAdd className='fs-3' /> {t("navbar.accomodation")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/view-interview`} className="nav-links" onClick={closeMobileMenu}>
                                                    <FaRegComments className='fs-3' /> {t("navbar.interview")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/view-transportation`} className="nav-links" onClick={closeMobileMenu}>
                                                    <IoCarOutline className='fs-3' /> {t("navbar.transportation")}
                                                </Link>
                                            </li> */}
                                            <li className='nav-item'>
                                                <Link to={customerUrl} target="_blank" rel="noopener noreferrer" className="nav-links" onClick={closeMobileMenu}>
                                                    <FaUserFriends className='fs-3' /> {t("navbar.chatbot")}
                                                </Link>
                                            </li>
                                            {/* <li className='nav-item'>
                                                <Link to="https://www.shineling.org:3001/pre-retreat" target="_blank" rel="noopener noreferrer" className="nav-links" onClick={closeMobileMenu}>
                                                    <MdOutlineEditCalendar className='fs-3' /> {t("navbar.preretreat")}
                                                </Link>
                                            </li> */}
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/course_registration`} className="nav-links" onClick={closeMobileMenu}>
                                                    <MdOutlineAppRegistration className='fs-3' /> {t("navbar.courseRegistration")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link to={`${base_url}/search_eligibility`} className="nav-links" onClick={closeMobileMenu} target="_blank" rel="noopener noreferrer">
                                                    <MdPublishedWithChanges className='fs-3' /> {t("navbar.eligibilityCheck")}
                                                </Link>
                                            </li>
                                            <li className='nav-item'>
                                                <Link className="nav-links-mobile" onClick={() => { closeMobileMenu(); logout(); }}>
                                                    <MdLogin className='fs-3' /> {t("navbar.logout")}
                                                </Link>
                                            </li>
                                        </>
                                    )}
                                </>
                        }
                    </ul>
                    <div className="d-flex justify-content-end">
                        <button className="language-icon" onClick={handleLanguageClick}><FaLanguage className='fs-3' /></button>
                        {button &&
                            <Button
                                disabled={true}
                                onClick={participation_type === null ? () => navigate(`${base_url}/login`) : logout}
                                buttonStyle='btn--primary'>
                                {t(participation_type === null ? "navbar.login" : "navbar.logout")}
                            </Button>
                        }
                    </div>
                </div>

            </nav >
        </>
    )
}

export default Navbar